export default __webpack_public_path__ + "static/media/affiche2018.b01bfed4.png";